import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";
import {BdpkDeveloperEnv} from "./bdpk-developer-env";

@jsonObject()
export class BdpkDeveloperEnvCategory {

  @jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: true })
  id: number;

  @jsonMember({ constructor: String, emitDefaultValue: false, isRequired: true })
  name: string;

  @jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: true })
  ord: number;

  @jsonMember({ constructor: String, emitDefaultValue: false, isRequired: true })
  description: string;

  @jsonMember({ constructor: String, emitDefaultValue: false, isRequired: true })
  imagePath: string;

  @jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false })
  createUserId: number;

  @jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false })
  createUserName: string;

  @jsonMember({ constructor: Date, emitDefaultValue: false, isRequired: false })
  createDate: Date;

  @jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false })
  changeUserId: number;

  @jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false })
  changeUserName: string;

  @jsonMember({ constructor: Date, emitDefaultValue: false, isRequired: false })
  changeDate: Date;

  @jsonArrayMember(BdpkDeveloperEnv, {emitDefaultValue: false, preserveNull: false, isRequired: false })
  devEnvironments: BdpkDeveloperEnv[] = [];


  isMenuOpen = false;
}
